import { getCategoryHref } from '../../utils/common/category';
import { DRAWING_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'drawingIdeaGeneratorType',
      analyticsName: 'drawing_idea_type',
      textLabel: 'Generate drawing ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: DRAWING_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Drawing',
        value: getCategoryHref(DRAWING_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'drawingIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'drawing_ideas_generator',
      placeholder: 'Try "something colorful" or "pet portrait"',
      textLabel: 'Describe what you want to draw',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: DRAWING_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
